var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98667 0.596541C8.85809 0.493592 8.69828 0.4375 8.53356 0.4375C8.36885 0.4375 8.20904 0.493592 8.08046 0.596541C7.81222 0.843031 0.5625 6.6863 0.5625 12.7616C0.5625 14.8766 1.40269 16.905 2.89823 18.4005C4.39378 19.8961 6.42217 20.7363 8.53719 20.7363C10.6522 20.7363 12.6806 19.8961 14.1761 18.4005C15.6717 16.905 16.5119 14.8766 16.5119 12.7616C16.5119 6.6863 9.26216 0.843031 8.98667 0.596541ZM8.53719 19.2863C6.80672 19.2863 5.14712 18.5989 3.9235 17.3753C2.69987 16.1516 2.01244 14.492 2.01244 12.7616C2.01244 8.19424 6.993 3.47468 8.53719 2.11173C10.0814 3.47468 15.0619 8.19424 15.0619 12.7616C15.0619 14.492 14.3745 16.1516 13.1509 17.3753C11.9273 18.5989 10.2677 19.2863 8.53719 19.2863Z",
    fill: "#FF6868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53769 16.3899C7.57632 16.3899 6.65432 16.008 5.97453 15.3282C5.29474 14.6484 4.91283 13.7264 4.91283 12.765C4.91283 12.5727 4.83645 12.3883 4.70049 12.2524C4.56454 12.1164 4.38014 12.04 4.18786 12.04C3.99559 12.04 3.81119 12.1164 3.67523 12.2524C3.53927 12.3883 3.46289 12.5727 3.46289 12.765C3.46289 14.1109 3.99756 15.4017 4.94927 16.3534C5.90098 17.3051 7.19177 17.8398 8.53769 17.8398C8.72997 17.8398 8.91437 17.7634 9.05032 17.6275C9.18628 17.4915 9.26266 17.3071 9.26266 17.1148C9.26266 16.9226 9.18628 16.7382 9.05032 16.6022C8.91437 16.4662 8.72997 16.3899 8.53769 16.3899Z",
    fill: "#FF6868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBp);
export default __webpack_public_path__ + "static/media/BP.42cd5f0cfcbaecbcba86d1940350d986.svg";
export { ForwardRef as ReactComponent };